import { render, staticRenderFns } from "./study-activites-packet.vue?vue&type=template&id=161ecb60&scoped=true&"
import script from "./study-activites-packet.vue?vue&type=script&lang=js&"
export * from "./study-activites-packet.vue?vue&type=script&lang=js&"
import style0 from "./study-activites-packet.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./study-activites-packet.vue?vue&type=style&index=1&id=161ecb60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161ecb60",
  null
  
)

component.options.__file = "study-activites-packet.vue"
export default component.exports